import React from "react";
import "./shimmer.css";

interface ShimmerProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  className?: string;
  style?: React.CSSProperties;
}

const Shimmer: React.FC<ShimmerProps> = ({
  width = "100%",
  height = "16px",
  borderRadius = "4px",
  className = "",
  style = {},
}) => {
  return (
    <div
      className={`shimmer-effect ${className}`}
      style={{
        width,
        height,
        borderRadius,
        ...style,
      }}
    />
  );
};

export default Shimmer;
